module.exports = __webpack_public_path__ + "img/dustbin.3dc97a54.svg";